/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */



import hwaxios from '../../../rmsReduxStore/api-service/HWAxios';
import { acChargerTypes } from '../acReduxExports'
import rmsStore from '../../../rmsReduxStore/rmsStore';
import { cloneDeep } from 'lodash';
import { getAcFilterSelectedValue, getCurrentAcFiltersValues, setAcFilterData } from '../acFiltersRedux/acFiltersCreators';
import { isAxiosError } from 'axios';
import { fetchAcAlarmSeverityReferenceData, fetchAcChargerProductTypeReferenceData, fetchAcChargerStationReferenceData, fetchAcCustomerReferenceData, fetchAcSoftwarVersionReferenceData } from '../acReferenceDataRedux/acReferenceDataCreator';
import { fetchChargerStatusReferenceData } from '../../../rmsReduxStore/reduxExports';
// import {isEqual } from 'lodash';
const url = process.env.REACT_APP_SERVER_BASE_URL_AC

// TODO: Charger List API
export const fetchAcChargersData: any = (reqBody: any) => async (dispatch: (arg0: Partial<AcChargerAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcChargerAction> = {
      type: acChargerTypes.AC_SET_CHARGER_LOADER,
      chargerTableLoader: true
    }
    dispatch(loaderStartAction);
    const searchHash = reqBody?.searchTerm && reqBody.searchTerm.trim() !== ''
          ? reqBody.searchTerm.trim() : null;
    const filterHash = reqBody?.filters;

    

    const hashAction: Partial<AcChargerAction> = {
      type: acChargerTypes.AC_SET_CHARGER_LIST_REQUEST_HASH,
      chargerListRequestHash: searchHash,
      chargersFilterHash: filterHash
    }
    dispatch(hashAction)

    const response = await hwaxios.post(url + '/chargers', reqBody)


      const action: Partial<AcChargerAction> = {
        type: acChargerTypes.AC_FETCH_CHARGERS_DATA,
        chargers: response.data?.data?.chargers,
        chargerCount: response.data?.data?.chargerCount,
      }
      dispatch(action)
    
    if (response?.status === 200) {
      const loaderEndAction: Partial<AcChargerAction> = {
        type: acChargerTypes.AC_SET_CHARGER_LOADER,
        chargerTableLoader: false
      }
      dispatch(loaderEndAction);
    }
  } catch (error) {
    const loaderEndAction: Partial<AcChargerAction> = {
      type: acChargerTypes.AC_SET_CHARGER_LOADER,
      chargerTableLoader: false
    }
    dispatch(loaderEndAction);
    console.error(error)
    throw error
  }
}


export const fetchAcChargerDetail: any = (reqParams: unknown) => async (dispatch: (arg0: Partial<AcChargerAction>) => any): Promise<any> => {
  try {
    const loaderStartAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_CHARGER_LOADER,
      chargerTableLoader: true
    }
    dispatch(loaderStartAction);

    const response = await hwaxios.get(url + '/charger', { params: reqParams })
    const action: Partial<AcChargerAction> = {
      type: acChargerTypes.FETCH_AC_CHARGER_DETAIL_DATA,
      chargerDetail: response?.data?.data,
    }
    dispatch(action)
    if (response?.status === 200) {
      const loaderEndAction: Partial<AcChargerAction> = {
        type: acChargerTypes.SET_AC_CHARGER_LOADER,
        chargerTableLoader: false
      }
      dispatch(loaderEndAction);
    }
    return response;
  } catch (error) {
    const loaderEndAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_CHARGER_LOADER,
      chargerTableLoader: false
    }
    dispatch(loaderEndAction);
    console.error(error)
    throw error
  }
}


export const setAcChargerListTableProps: any = (data) => async (dispatch: (arg0: Partial<ChargerAction>) => void): Promise<void> => {
  const action: Partial<AcChargerAction> = {
    type: acChargerTypes.SET_AC_CHARGER_LIST_TABLE_PROPS,
    chargerListTableProps: data,
  };
  dispatch(action);
}


export const fetchIndividualAcChargerDetail: any = (reqParams: unknown) => async (dispatch: (arg0: Partial<AcChargerAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcChargerAction> = {
      type: acChargerTypes.AC_SET_CHARGER_LOADER,
      individualChargerDetailLoader: true
    }
    dispatch(loaderStartAction);
    const response = await hwaxios.get(url + '/charger/detail', { params: reqParams })
    const action: Partial<AcChargerAction> = {
      type: acChargerTypes.FETCH_INDIVIDUAL_AC_CHARGER_DETAIL_DATA,
      individualChargerDetail: response?.data?.data,
      lastRefreshTime: new Date().toISOString(),

    }
    dispatch(action)
    if (response?.status === 200) {
      const loaderEndAction: Partial<AcChargerAction> = {
        type: acChargerTypes.AC_SET_CHARGER_LOADER,
        individualChargerDetailLoader: false
      }
      dispatch(loaderEndAction);
    }
  } catch (error) {
    const loaderEndAction: Partial<AcChargerAction> = {
      type: acChargerTypes.AC_SET_CHARGER_LOADER,
      individualChargerDetailLoader: false
    }
    dispatch(loaderEndAction);
    console.error(error)
    throw error
  }
}



export const fetchAcChargerStatusMasterInfo: any = (reqParams: any) => async (dispatch: (arg0: Partial<ChargerAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
      individualChargerDetailLoader: true
    }
    dispatch(loaderStartAction);
    const response = await hwaxios.get( url + '/charger/status/master', { params: reqParams });

      const action: Partial<AcChargerAction> = {
        type: acChargerTypes.FETCH_AC_CHARGER_STATUS_MASTER_INFO_DATA,
        chargerStatusMasterInfo: response?.data?.data
      }
      dispatch(action)
      if (response?.status === 200) {
        const loaderEndAction: Partial<AcChargerAction> = {
          type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
          individualChargerDetailLoader: false
        }
        dispatch(loaderEndAction);
      }
  

  } catch (error) {
    const loaderEndAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
      individualChargerDetailLoader: false
    }
    dispatch(loaderEndAction);
    console.error(error)
    throw error
  }
}

export const fetchAcChargerStatusSystemInfo: any = (reqParams: unknown) => async (dispatch: (arg0: Partial<AcChargerAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
      individualChargerDetailLoader: true
    }
    dispatch(loaderStartAction);
    const response = await hwaxios.get(url + '/charger/status', { params: reqParams })
    const action: Partial<AcChargerAction> = {
      type: acChargerTypes.FETCH_AC_CHARGER_STATUS_SYSTEM_INFO_DATA,
      chargerStatusSystemInfo: response?.data?.data

    }
    dispatch(action)
    if (response?.status === 200) {
      const loaderEndAction: Partial<AcChargerAction> = {
        type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
        individualChargerDetailLoader: false
      }
      dispatch(loaderEndAction);
    }
  } catch (error) {
    const loaderEndAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
      individualChargerDetailLoader: false
    }
    dispatch(loaderEndAction);
    console.error(error)
    throw error
  }
}


export const fetchAcChargerMasterInfo: any = (reqParams: any) => async (dispatch: (arg0: Partial<ChargerAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
      individualChargerDetailLoader: true
    }
    dispatch(loaderStartAction);
   const response = await hwaxios.get( url + '/charger/system-info/master', { params: reqParams })
  
      const action: Partial<AcChargerAction> = {
        type: acChargerTypes.FETCH_AC_MASTER_INFO_DATA,
        chargerMasterInfo: response?.data?.data
      }
      dispatch(action)
      if (response?.status === 200) {
        const loaderEndAction: Partial<AcChargerAction> = {
          type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
          individualChargerDetailLoader: false
        }
        dispatch(loaderEndAction);
      }
    


  } catch (error) {
    const loaderEndAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
      individualChargerDetailLoader: false
    }
    dispatch(loaderEndAction);
    console.error(error)
    throw error
  }
}

export const fetchAcChargerSystemInfo: any = (reqParams: unknown) => async (dispatch: (arg0: Partial<ChargerAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
      individualChargerDetailLoader: true
    }
    dispatch(loaderStartAction);
    const response = await hwaxios.get( url + '/charger/system-info', { params: reqParams })
    const action: Partial<AcChargerAction> = {
      type: acChargerTypes.FETCH_AC_SYSTEM_INFO_DATA,
      chargerSystemInfo: response?.data?.data

    }
    dispatch(action)
    if (response?.status === 200) {
      const loaderEndAction: Partial<AcChargerAction> = {
        type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
        individualChargerDetailLoader: false
      }
      dispatch(loaderEndAction);
    }
  } catch (error) {
    const loaderEndAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
      individualChargerDetailLoader: false
    }
    dispatch(loaderEndAction);
    console.error(error)
    throw error
  }
}


export const fetchAcChargerSettingsMasterInfo: any = (reqParams: any) => async (dispatch: (arg0: Partial<ChargerAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
      individualChargerDetailLoader: true
    }
    dispatch(loaderStartAction);

  const response = await hwaxios.get( url + '/charger/setting/master', { params: reqParams })
      const action: Partial<AcChargerAction> = {
        type: acChargerTypes.FETCH_AC_CHARGER_SETTINGS_MASTER_INFO_DATA,
        chargerSettingsMasterInfo: response?.data?.data
      }
      dispatch(action)
      if (response?.status === 200) {
        const loaderEndAction: Partial<AcChargerAction> = {
          type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
          individualChargerDetailLoader: false
        }
        dispatch(loaderEndAction);
      }
    


  } catch (error) {
    const loaderEndAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
      individualChargerDetailLoader: false
    }
    dispatch(loaderEndAction);
    console.error(error)
    throw error
  }
}

// TODO: Charger Settings System Info  API
export const fetchAcChargerSettingsSystemInfo: any = (reqParams: unknown) => async (dispatch: (arg0: Partial<ChargerAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
      individualChargerDetailLoader: true
    }
    dispatch(loaderStartAction);

    const response = await hwaxios.get(url + '/charger/setting', { params: reqParams })
    const action: Partial<AcChargerAction> = {
      type: acChargerTypes.FETCH_AC_CHARGER_SETTINGS_SYSTEM_INFO_DATA,
      chargerSettingsSystemInfo: response?.data?.data

    }
    dispatch(action)
    if (response?.status === 200) {
      const loaderEndAction: Partial<AcChargerAction> = {
        type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
        individualChargerDetailLoader: false
      }
      dispatch(loaderEndAction);
    }
  } catch (error) {
    const loaderEndAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
      individualChargerDetailLoader: false
    }
    dispatch(loaderEndAction);
    console.error(error)
    throw error
  }
}
export const fetchAllowedAcCommandsForRole: any =
  (chargerId) =>
    async (
      dispatch: (arg0: Partial<AcChargerAction>) => void
    ): Promise<void> => {
      try {
        const response = await hwaxios.get(url + `/charger/remote-command/master?chargerId=${chargerId}`).then((response) => {
          const action: Partial<AcChargerAction> = {
            type: acChargerTypes.FETCH_ALLOWED_AC_COMMANDS_FOR_ROLE_REFERENCE_DATA,
            allowedCommandsForRoleReferenceData: response?.data?.data,
          };
          dispatch(action);

        });
        return response;
      } catch (error) {
        console.log(error);
        throw error;
      }
    };

  export const updateAcChargerSettingsParameters: any = (reqParams: unknown) => async (dispatch: (arg0: Partial<AcChargerAction>) => void): Promise<unknown> => {
  try {
    const loaderStartAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
      individualChargerDetailLoader: true
    }
    dispatch(loaderStartAction);
    const response = await hwaxios.put(url +'/charger/setting/configure', reqParams)
    if (response?.status === 200) {
      const loaderEndAction: Partial<AcChargerAction> = {
        type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
        individualChargerDetailLoader: false
      }
      dispatch(loaderEndAction);
      return response?.data
    }
  } catch (error) {
    const loaderEndAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
      individualChargerDetailLoader: false
    }
    dispatch(loaderEndAction);
    console.error(error)
    throw error
  }
}


export const fetchChargerConnectorStatus: any = (reqParams) => async (dispatch: (arg0: Partial<AcChargerAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
      individualChargerDetailLoader: true
    }
    dispatch(loaderStartAction);
    const response = await hwaxios.get( url +'/connector/status', { params: reqParams })
    const action: Partial<AcChargerAction> = {
      type: acChargerTypes.FETCH_AC_CHARGER_CONNECTOR_STATUS_DATA,
      chargerConnectorStatus: response?.data?.data?.connectorStatus,
      chargerNetwork: response?.data?.data?.chargerNetwork,
      lastRefreshTime: response?.data?.data?.lastRefreshTime,
    }
    dispatch(action)
    if (response?.status === 200) {
      const loaderEndAction: Partial<AcChargerAction> = {
        type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
        individualChargerDetailLoader: false
      }
      dispatch(loaderEndAction);
    }
  } catch (error) {
    const loaderEndAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
      individualChargerDetailLoader: false
    }
    dispatch(loaderEndAction);
    console.error(error)
    throw error
  }
}



export const modifyAcChargerHistoryGraphData: any = (
  response: IAcChargerHistoryGraph,
  action: 'SET' | 'REMOVE',
  removeKey?: string,
  removeKeyType?: 'parameter' | 'connector'
): IAcChargerHistoryGraph => {

  const prevState =
    rmsStore.getState().acChargersReducer.chargerHistoryGraphData;

  if (action === 'SET') {
    if (!prevState) {
      return response;
    }

    const updatedData = cloneDeep(prevState);
    const previousFilterHashes = cloneDeep(
      rmsStore.getState().acChargersReducer.chargerHistoryGraphFilterHashes
    );

    // Respect your filterHash logic
    if (!previousFilterHashes?.includes(response?.filterHash)) {
      return updatedData;
    }

    response.data.forEach(newItem => {
      const index = updatedData.data.findIndex(
        item =>
          item.connectorName === newItem.connectorName &&
          item.parameterName === newItem.parameterName
      );

      if (index !== -1) {
        //  UPDATE existing history
        updatedData.data[index] = newItem;
      } else {
        // ADD new history
        updatedData.data.push(newItem);
      }
    });

    return updatedData;
  }
  if (action === 'REMOVE' && removeKey && removeKeyType) {
    const previousData = cloneDeep(prevState);
    previousData.data = previousData?.data?.filter((item) => {
      if (removeKeyType === 'parameter') return item.parameterName !== removeKey;
      return item.connectorName !== removeKey;
    });
    return previousData;
  }

  return prevState;
};



// export const modifyAcChargerHistoryGraphData: any = (
//   response: IAcChargerHistoryGraph,
//   action: 'SET' | 'REMOVE',
//   removeKey?: string,
//   removeKeyType?: 'parameter' | 'connector'
// ): IAcChargerHistoryGraph => {

//   const prevState =
//     rmsStore.getState().acChargersReducer.chargerHistoryGraphData;

//   const previousFilterHashes = rmsStore.getState().acChargersReducer.chargerHistoryGraphFilterHashes

//     console.log('prev state', prevState , 'previous filter hashes',previousFilterHashes)

//   if (action === 'SET') {

//     // First response OR graph was cleared
//     if (!prevState || !prevState.data || prevState.data.length === 0) {
//       return response;
//     }

//     const updatedData = cloneDeep(prevState);

//     //  Always append — bulk calls arrive async
//     updatedData.data.push(...response.data);

//     return updatedData;
//   }

//   if (action === 'REMOVE' && removeKey && removeKeyType) {
//     const previousData = cloneDeep(prevState);
//     previousData.data = previousData?.data?.filter((item) => {
//       if (removeKeyType === 'parameter') return item.parameterName !== removeKey;
//       return item.connectorName !== removeKey;
//     });
//     return previousData;
//   }

//   return prevState;
// };


export const fetchAcChargerGraphDetail: any = (reqBody: unknown) => async (dispatch: (arg0: Partial<AcChargerAction>) => unknown): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
      individualChargerDetailLoader: true
    }
    dispatch(loaderStartAction);
    const response = await hwaxios.post(url + '/charger/trend', reqBody)
    const action: Partial<AcChargerAction> = {
      type: acChargerTypes.FETCH_AC_CHARGER_GRAPH_DETAIL,
      chargerHistoryGraphData: modifyAcChargerHistoryGraphData(response?.data?.data, 'SET')
    }

    dispatch(action)
    if (response?.status === 200) {
      const loaderEndAction: Partial<AcChargerAction> = {
        type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
        individualChargerDetailLoader: false
      }
      dispatch(loaderEndAction);
    }
  } catch (error) {
    const loaderEndAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
      individualChargerDetailLoader: false
    }
    dispatch(loaderEndAction);
    console.error(error)
    throw error
  }
}


export const setAcChargerHistoryGraphFilterHash: any = (action: 'SET' | 'REMOVE', historyType, connectorId, removeKey?: string, removeKeyType?: 'parameter' | 'connector') => (dispatch: (arg0: Partial<AcChargerAction>) => void): string | null => {

  let updatedData = cloneDeep(rmsStore.getState().acChargersReducer.chargerHistoryGraphFilterHashes)

  let hashValue: string = ''
  const selectedStatType = getAcFilterSelectedValue('statType', 'acchargerPanel', false)?.[0]?.id
  const selectedStatInterval = getAcFilterSelectedValue('statInterval', 'acchargerPanel', false)?.[0]?.id
  const selectedHistoryInterval = getAcFilterSelectedValue('statInterval', 'acchargerPanel', false)?.[0]?.id
  const selectedConnectors = getAcFilterSelectedValue('connectorId', 'acchargerPanel', false)
  if (action === 'SET') {
    hashValue = historyType + '#' + connectorId + '#' + selectedStatInterval + '#' + selectedStatType + '#' + selectedHistoryInterval;
    updatedData.push(hashValue);

  }
  if (action === 'REMOVE' && removeKey && removeKeyType) {
    if (removeKeyType === 'connector') {
      updatedData = updatedData?.filter(item => !item?.includes(removeKey))
    } else {
      const hashToRemove: string[] = []
      selectedConnectors?.forEach(connector => {
        hashValue = removeKey + '#' + connector?.id + '#' + selectedStatInterval + '#' + selectedStatType + '#' + selectedHistoryInterval;
        hashToRemove?.push(hashValue)
      })
      updatedData = updatedData?.filter(item => !hashToRemove?.includes(item))
    }
  }
  const chargerAction: Partial<AcChargerAction> = {
    type: acChargerTypes.SET_AC_CHARGER_HISTORY_GRAPH_FILTER_HASHES,
    chargerHistoryGraphFilterHashes: updatedData
  }
  dispatch(chargerAction)
  return hashValue
}

export const fetchAcChargerGraphDetailBulk: any = (reqParams: any) => async (dispatch): Promise<void> => {
  const filters = getCurrentAcFiltersValues('acchargerPanel', true)
  const remainingFilters = filters?.filter?.((filter) => filter?.key !== 'connectorId' && filter.key !== 'historyType')
  const selectedConnectors = filters?.find((filter) => filter?.key === 'connectorId')
  const selectedHistoryTypes = filters?.find((filter) => filter?.key === 'historyType')
  selectedConnectors?.values?.forEach(connector => {
    selectedHistoryTypes?.values?.forEach(historyType => {
      let filtersToUpdate = cloneDeep(remainingFilters)
      filtersToUpdate = filtersToUpdate?.concat([{ key: 'historyType', values: [historyType] }, { key: 'connectorId', values: [connector] }])
      const filterHash = dispatch(setAcChargerHistoryGraphFilterHash('SET', historyType, connector))
      dispatch(fetchAcChargerGraphDetail({
        chargerId: reqParams?.chargerId,
        filterHash: filterHash,
        filters: filtersToUpdate
      }))
    });
  });
}
export const clearAcChargerHistoryGraphData: any = () => async (dispatch: (arg0: Partial<AcChargerAction>) => void): Promise<void> => {
  const updatedData = cloneDeep(rmsStore.getState().acChargersReducer.chargerHistoryGraphData)
  updatedData.data = []
  const action: Partial<AcChargerAction> = {
    type: acChargerTypes.CLEAR_AC_CHARGER_GRAPH_DETAIL,
    chargerHistoryGraphData: updatedData
  }
  dispatch(action)
  const chargerAction: Partial<AcChargerAction> = {
    type: acChargerTypes.SET_AC_CHARGER_HISTORY_GRAPH_FILTER_HASHES,
    chargerHistoryGraphFilterHashes: []
  }
  dispatch(chargerAction)
}


export const fetchAcChargerConnectorStatusLogs: any = (reqBody: unknown) => async (dispatch: (arg0: Partial<AcChargerAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
      individualChargerDetailLoader: true
    }
    dispatch(loaderStartAction);
    const response = await hwaxios.post( url + '/charger/connector-status-logs', reqBody)
    const action: Partial<AcChargerAction> = {
      type: acChargerTypes.FETCH_AC_CHARGER_STATUS_LOGS,
      chargerConnectorStatusLogs: response?.data?.data
    }
    dispatch(action)
    if (response?.status === 200) {
      const loaderEndAction: Partial<AcChargerAction> = {
        type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
        individualChargerDetailLoader: false
      }
      dispatch(loaderEndAction);
    }
  } catch (error) {
    const loaderEndAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
      individualChargerDetailLoader: false
    }
    dispatch(loaderEndAction);
    console.error(error)
    throw error
  }
}


export const fetchAcParametersData: any = (reqBody: unknown) => async (dispatch: (arg0: Partial<AcChargerAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_PARAMETERS_LOADER,
      chargerParametersTableLoader: true
    }
    dispatch(loaderStartAction);
    const response = await hwaxios.post(url + '/charger-parameters', reqBody)
    const action: Partial<AcChargerAction> = {
      type: acChargerTypes.FETCH_AC_PARAMETERS_DATA,

      chargerParameters: response.data?.data?.resultParams,
      chargerParametersCount: response.data?.data?.paramsCount,
    }

    dispatch(action)
    if (response?.status === 200 || response?.status === 202) {
      const loaderEndAction: Partial<AcChargerAction> = {
        type: acChargerTypes.SET_AC_PARAMETERS_LOADER,
        chargerParametersTableLoader: false
      }
      dispatch(loaderEndAction);
    }
  } catch (error) {
    const loaderEndAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_PARAMETERS_LOADER,
      chargerParametersTableLoader: false
    }
    dispatch(loaderEndAction);
    console.error(error)
    throw error
  }
}

export const fetchAcParametersDevicesData: any = (reqBody: unknown) => async (dispatch: (arg0: Partial<AcChargerAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_PARAMETERS_DEVICES_LOADER,
      chargerParametersDevicesTableLoader: true
    }
    dispatch(loaderStartAction);
    const response = await hwaxios.post(url + '/charger-parameter/devices', reqBody)
    const action: Partial<AcChargerAction> = {
      type: acChargerTypes.FETCH_AC_PARAMETERS_DEVICES_DATA,

      chargerParametersDevices: response.data?.data?.devices,
      chargerParametersDevicesCount: response.data?.data?.total,
    }


    dispatch(action)
    if (response?.status === 200 || response?.status === 202) {
      const loaderEndAction: Partial<AcChargerAction> = {
        type: acChargerTypes.SET_AC_PARAMETERS_DEVICES_LOADER,
        chargerParametersDevicesTableLoader: false
      }
      dispatch(loaderEndAction);
    }
  } catch (error) {
    const loaderEndAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_PARAMETERS_DEVICES_LOADER,
      chargerParametersDevicesTableLoader: false
    }
    dispatch(loaderEndAction);
    console.error(error)
    throw error
  }
}

export const fetchAcParameterDevicesStatusData: any = (reqParams) => async (dispatch): Promise<void> => {
  try {
    const response = await hwaxios.post(url + '/charger-parameter/count', reqParams);

    const action: Partial<AcChargerAction> = {
      type: acChargerTypes.FETCH_AC_PARAMETER_DEVICES_STATUS_COUNT,
      parameterDevicesStatusCount: response?.data?.data,
    };
    dispatch(action);
  } catch (error) {
    console.error(error);

    throw error;
  }
};


export const setAcChargerParametersDevicesListTableProps: any = (data) => async (dispatch: (arg0: Partial<AcChargerAction>) => void): Promise<void> => {
  const action: Partial<AcChargerAction> = {
    type: acChargerTypes.SET_AC_CHARGER_PARAMETERS_DEVICES_LIST_TABLE_PROPS,
    chargerParametersDevicesListTableProps: data,
  };
  dispatch(action);
}


export const fetchParametersAcSettingsSystemInfo: any = (reqParams: unknown) => async (dispatch: (arg0: Partial<AcChargerAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_PARAMETERS_DETAIL_LOADER,
      parametersDetailLoader: true
    }
    dispatch(loaderStartAction);
    const response = await hwaxios.post(url + '/charger/setting/values', reqParams)
    const action: Partial<AcChargerAction> = {
      type: acChargerTypes.FETCH_AC_PARAMETERS_SETTINGS_SYSTEM_INFO_DATA,
      parametersSettingsSystemInfo: response?.data?.data
    }
    dispatch(action)
    if (response?.status === 200) {
      const loaderEndAction: Partial<AcChargerAction> = {
        type: acChargerTypes.SET_AC_PARAMETERS_DETAIL_LOADER,
        parametersDetailLoader: false
      }
      dispatch(loaderEndAction);
    }
  } catch (error) {
    const loaderEndAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_PARAMETERS_DETAIL_LOADER,
      parametersDetailLoader: false
    }
    dispatch(loaderEndAction);
    console.error(error)
    throw error
  }
}


export const fetchParametersAcSettingsMasterInfo: any = (reqParams: unknown) => async (dispatch: (arg0: Partial<AcChargerAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_PARAMETERS_DETAIL_LOADER,
      parametersDetailLoader: true
    }
    dispatch(loaderStartAction);
    const response = await hwaxios.post(url + '/charger/setting/master-common', reqParams)
    const action: Partial<AcChargerAction> = {
      type: acChargerTypes.FETCH_AC_CHARGER_PARAMETERS_SETTINGS_MASTER_INFO_DATA,
      chargerParametersSettingsMasterInfo: response?.data?.data
    }
    dispatch(action)
    if (response?.status === 200) {
      const loaderEndAction: Partial<AcChargerAction> = {
        type: acChargerTypes.SET_AC_PARAMETERS_DETAIL_LOADER,
        parametersDetailLoader: false
      }
      dispatch(loaderEndAction);
    }
  } catch (error) {
    const loaderEndAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_PARAMETERS_DETAIL_LOADER,
      parametersDetailLoader: false
    }
    dispatch(loaderEndAction);
    console.error(error)
    throw error
  }
}


export const fetchAddParameterRefAcChargers: any = (reqParams) => async (dispatch): Promise<void> => {
  try {
    const response = await hwaxios.post(url + '/ref/charger-visible-id', reqParams);

    const action: Partial<AcChargerAction> = {
      type: acChargerTypes.FETCH_ADD_AC_PARAMETERS_REF_CHARGERS,
      addParameterRefChargers: response?.data?.data,
    };
    dispatch(action);
  } catch (error) {
    console.error(error);

    throw error;
  }
};


export const fetchAddParameterRefAcChargingStations: any = (reqParams) => async (dispatch): Promise<void> => {
  try {
    const response = await hwaxios.get(url + '/ref/charging-station', reqParams);

    const action: Partial<AcChargerAction> = {
      type: acChargerTypes.FETCH_ADD_AC_PARAMETERS_REF_CHARGING_STATIONS,
      addParameterRefChargingStations: response?.data?.data,
    };
    dispatch(action);
  } catch (error) {
    console.error(error);

    throw error;
  }
};



export const setAcChargerParametersListTableProps: any = (data) => async (dispatch: (arg0: Partial<AcChargerAction>) => void): Promise<void> => {
  const action: Partial<AcChargerAction> = {
    type: acChargerTypes.SET_AC_CHARGER_PARAMETERS_LIST_TABLE_PROPS,
    chargerParametersListTableProps: data,
  };
  dispatch(action);
}


export const createAcCharger: any = (reqParams: unknown) => async () => {
  try {
    const { data, status } = await hwaxios.post(url + '/charger', reqParams)
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: 'Something went wrong', status: 400
      }
    }
  }
}


export const updateAcCharger: any = (reqParams: unknown) => async () => {
  try {
    const { data, status } = await hwaxios.put(url + '/charger', reqParams)
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: 'Something went wrong', status: 400
      }
    }
  }
}
export const deleteAcParameter: any = (reqParams: unknown) => async () => {
  try {
    const { data, status } = await hwaxios.delete(url + '/charger-parameter', { params: reqParams })
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: 'Something went wrong', status: 400
      }
    }
  }
}

export const exportToCsvForAcParametersList: any = (reqParams: unknown) => async () => {
  try {
    const { data, status } = await hwaxios.post(url + '/charger-parameter/export', reqParams)
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: 'Something went wrong', status: 400
      }
    }
  }
}


export const fetchIndividualAcParameterDetail: any = (reqParams: unknown) => async (dispatch: (arg0: Partial<AcChargerAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_PARAMETERS_DETAIL_LOADER,
      parametersDetailLoader: true
    }
    dispatch(loaderStartAction);
    const response = await hwaxios.get(url + '/charger-parameter', { params: reqParams })
    const action: Partial<AcChargerAction> = {
      type: acChargerTypes.FETCH_AC_INDIVIDUAL_PARAMETER_DETAIL_DATA,
      individualParameterDetail: response?.data?.data,
    }
    dispatch(action)
    if (response?.status === 200) {
      const loaderEndAction: Partial<AcChargerAction> = {
        type: acChargerTypes.SET_AC_PARAMETERS_DETAIL_LOADER,
        parametersDetailLoader: false
      }
      dispatch(loaderEndAction);
    }
  } catch (error) {
    const loaderEndAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_PARAMETERS_DETAIL_LOADER,
      parametersDetailLoader: false
    }
    dispatch(loaderEndAction);
    console.error(error)
    throw error
  }
}


export const fetchAddAcParametersListDetail: any = (reqParams: unknown) => async (dispatch: (arg0: Partial<AcChargerAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcChargerAction> = {
      type: acChargerTypes.FETCH_ADD_AC_PARAMETERS_DETAIL_LIST,
      addParametersDetailsListLoader: true
    }
    dispatch(loaderStartAction);
    const response = await hwaxios.get(url + '/charger/setting/master/charger-level', { params: reqParams })
    const action: Partial<AcChargerAction> = {
      type: acChargerTypes.FETCH_ADD_AC_PARAMETERS_DETAIL_LIST,
      addParametersDetailsList: response?.data?.data,

    }
    dispatch(action)
    if (response?.status === 200) {
      const loaderEndAction: Partial<AcChargerAction> = {
        type: acChargerTypes.FETCH_ADD_AC_PARAMETERS_DETAIL_LIST,
        addParametersDetailsListLoader: false
      }
      dispatch(loaderEndAction);
    }
  } catch (error) {
    const loaderEndAction: Partial<AcChargerAction> = {
      type: acChargerTypes.FETCH_ADD_AC_PARAMETERS_DETAIL_LIST,
      addParametersDetailsListLoader: false
    }
    dispatch(loaderEndAction);
    console.error(error)
    throw error
  }
}


export const createAcParameters: any = (reqParams: unknown) => async () => {
  try {
    const { data, status } = await hwaxios.post(url + '/charger-parameter', reqParams)
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: 'Something went wrong', status: 400
      }
    }
  }
}



export const fetchAcChargerUpdateCommandsData: any = (reqBody: unknown) => async (dispatch: (arg0: Partial<AcChargerAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_PARAMETERS_LOADER,
      chargerParametersTableLoader: true
    }
    dispatch(loaderStartAction);
    const response = await hwaxios.post(url + '/charger-update-commands', reqBody)
    const action: Partial<AcChargerAction> = {
      type: acChargerTypes.FETCH_AC_UPDATE_COMMANDS_DATA,
      chargerUpdateCommands: response.data?.data?.resultCommands ?? [],
      chargerUpdateCommandsCount: response.data?.data?.commandsCount,
    }
    dispatch(action)
    if (response?.status === 200 || response?.status === 202) {
      const loaderEndAction: Partial<AcChargerAction> = {
        type: acChargerTypes.SET_AC_PARAMETERS_LOADER,
        chargerParametersTableLoader: false
      }
      dispatch(loaderEndAction);
    }
  } catch (error) {
    const loaderEndAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_PARAMETERS_LOADER,
      chargerParametersTableLoader: false
    }
    dispatch(loaderEndAction);
    console.error(error)
    throw error
  }
}


export const setAcChargerUpdateCommandsListTableProps: any = (data) => async (dispatch: (arg0: Partial<AcChargerAction>) => void): Promise<void> => {
  const action: Partial<AcChargerAction> = {
    type: acChargerTypes.SET_AC_CHARGER_UPDATE_COMMANDS_LIST_TABLE_PROPS,
    chargerUpdateCommandsListTableProps: data,
  };
  dispatch(action);
}


export const fetchUpdateAcCommandDevicesData: any = (reqBody: unknown) => async (dispatch: (arg0: Partial<AcChargerAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_PARAMETERS_DEVICES_LOADER,
      chargerParametersDevicesTableLoader: true
    }
    dispatch(loaderStartAction);
    const response = await hwaxios.post(url + '/charger-update-command/devices', reqBody)
    const action: Partial<AcChargerAction> = {
      type: acChargerTypes.FETCH_UPDATE_AC_COMMANDS_DEVICES_DATA,
      chargerUpdateCommandDevices: response.data?.data?.devices,
      chargerUpdateCommandDevicesCount: response.data?.data?.total,
    }
    dispatch(action)
    if (response?.status === 200 || response?.status === 202) {
      const loaderEndAction: Partial<AcChargerAction> = {
        type: acChargerTypes.SET_AC_PARAMETERS_DEVICES_LOADER,
        chargerParametersDevicesTableLoader: false
      }
      dispatch(loaderEndAction);
    }
  } catch (error) {
    const loaderEndAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_PARAMETERS_DEVICES_LOADER,
      chargerParametersDevicesTableLoader: false
    }
    dispatch(loaderEndAction);
    console.error(error)
    throw error
  }
}



export const fetchUpdateAcCommandDevicesStatusData: any = (reqParams) => async (dispatch): Promise<void> => {
  try {
    const response = await hwaxios.post(url + '/charger-update-command/count', reqParams);
    const action: Partial<AcChargerAction> = {
      type: acChargerTypes.FETCH_UPDATE_AC_COMMAND_DEVICES_STATUS_COUNT,
      updateCommandDevicesStatusCount: response?.data?.data,
    };
    dispatch(action);
  } catch (error) {
    console.error(error);

    throw error;
  }
};


export const setAcChargerUpdateCommandDevicesListTableProps: any = (data) => async (dispatch: (arg0: Partial<AcChargerAction>) => void): Promise<void> => {
  const action: Partial<AcChargerAction> = {
    type: acChargerTypes.SET_AC_CHARGER_UPDATE_COMMANDS_DEVICES_LIST_TABLE_PROPS,
    chargerUpdateCommandDevicesListTableProps: data,
  };
  dispatch(action);
}


export const exportToCsvForUpdateAcCommandsList: any = (reqParams: unknown) => async () => {
  try {
    const { data, status } = await hwaxios.post(url + '/charger-update-command/export', reqParams)
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: 'Something went wrong', status: 400
      }
    }
  }
}

export const deleteUpdateAcCommand: any = (reqParams: unknown) => async () => {
  try {
    const { data, status } = await hwaxios.delete(url + '/charger-delete-command', { params: reqParams })
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: 'Something went wrong', status: 400
      }
    }
  }
}



export const setRedirectedStateForAcChargerFilters: any = (data, chargerStatusId?: string, customerId?: string, chargingStationId?: string, screen?: 'acdashboard' | 'customers' | 'chargingStations' | 'versionReleases' | 'versionReleasesDashboard',onlyExternalCustomers?:any,versionProductType?:string,softwareVersion?:string,allExceptGivenVersion?:boolean) => async (dispatch) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      const action = {
        type: acChargerTypes.SET_AC_FILTERS_APPLIED_FROM_REDIRECTION,
        chargerFiltersAppliedFromRedirection: data,
      };
      if(screen === 'acdashboard') {
        const productType = getAcFilterSelectedValue('productType', 'acdashboard', false)
        if(productType) {
          await setAcFilterData(productType, 'productType', 'acchargers', 'SET', false)(dispatch)
        }
         if(onlyExternalCustomers){
          await setAcFilterData(onlyExternalCustomers, 'customer', 'acchargers', 'SET', true)(dispatch)
        }
      }

      if(screen === 'versionReleasesDashboard' || screen === 'versionReleases'){
        const chargerProductTypeReferenceData = (rmsStore.getState().referenceDataReducer.chargerProductTypeReferenceData) ? rmsStore.getState().referenceDataReducer?.chargerProductTypeReferenceData : JSON.parse(await dispatch(fetchAcChargerProductTypeReferenceData()))
        const productType = chargerProductTypeReferenceData?.filter(item=>item.name === versionProductType)
        if(productType){
          await setAcFilterData(productType, 'productType', 'acchargers', 'SET', false)(dispatch)
        }
        if(softwareVersion){

            const softwareVersionReferenceData = (rmsStore.getState().referenceDataReducer.softwareVersionReferenceData) ? rmsStore.getState().referenceDataReducer?.softwareVersionReferenceData : JSON.parse(await dispatch(fetchAcSoftwarVersionReferenceData()))
            const softwareVersions = allExceptGivenVersion ? softwareVersionReferenceData?.filter(item=>item.name!==softwareVersion && item.name!=='All') : softwareVersionReferenceData?.filter(item=>item.name===softwareVersion);
            await setAcFilterData(softwareVersions, 'softwareVersion', 'acchargers', 'SET', false)(dispatch)
        }
         if(onlyExternalCustomers){
          await setAcFilterData(onlyExternalCustomers, 'customer', 'acchargers', 'SET', true)(dispatch)
        }
      }
      if (chargerStatusId === 'Offline' || chargerStatusId === 'Online' ||  chargerStatusId==='OfflinMoreThan5Days' || chargerStatusId==='RmsDisable' || chargerStatusId === 'Faulty' || chargerStatusId === 'Healthy' || customerId || chargingStationId) {
        let severitySelected: Array<string> = [];
        if (customerId) {
          if (!rmsStore.getState().referenceDataReducer?.customerReferenceData) {
            await dispatch(fetchAcCustomerReferenceData())
          }
          const customer = rmsStore.getState().referenceDataReducer?.customerReferenceData?.find(customer => customer?.id === customerId)
          if (customer) {
          setAcFilterData(customer, 'customer', 'acchargers', 'SET', true)(dispatch);
          }
        }
        if (chargingStationId) {
          const chargingStationRefData = (rmsStore.getState().referenceDataReducer.chargingStationReferenceData) ? rmsStore.getState().referenceDataReducer?.chargingStationReferenceData : JSON.parse(await dispatch(fetchAcChargerStationReferenceData()));
          const chargingStation = chargingStationRefData?.find(chargingStation => chargingStation?.id === chargingStationId)
          if (chargingStation) {
            await setAcFilterData(chargingStation, 'chargingStationId', 'acchargers', 'SET', false)(dispatch);
          }
        }

        if (chargerStatusId === 'Faulty') {
          chargerStatusId = 'Online'
          severitySelected.push('Critical')
        } else if (chargerStatusId === 'Healthy') {
          chargerStatusId = 'Online'
          severitySelected = severitySelected.concat(['No Alarm', 'Major', 'Minor'])
        }

        const chargerStatusReferenceDataVal = (rmsStore.getState().referenceDataReducer.chargerStatusReferenceData) ? rmsStore.getState().referenceDataReducer?.chargerStatusReferenceData : JSON.parse(await dispatch(fetchChargerStatusReferenceData()));
        if (!rmsStore.getState().referenceDataReducer?.alarmSeverityReferenceData) {
          await dispatch(fetchAcAlarmSeverityReferenceData())
        }
        const status = chargerStatusReferenceDataVal?.find(chargerStatus => chargerStatus?.id === chargerStatusId)
        const severity = rmsStore.getState().referenceDataReducer?.alarmSeverityReferenceData?.filter(severity => severitySelected?.includes(severity?.id))
        if (status) {
          await setAcFilterData(status, 'chargerStatus', 'acchargers', 'SET', false)(dispatch);
        }
        if (severity && severity?.length > 0) {
          await setAcFilterData(severity, 'alarmStatus', 'acchargers', 'SET', false)(dispatch);
        }

      }
      await dispatch(action);
      // Resolve the promise
      resolve('Action dispatched successfully');
    } catch (error) {
      // Reject the promise with the error
      reject(error);
    }
  });
};


export const exportBulkAcChargerUploadTemplate: any = () => async () => {
  try {
    const response = await hwaxios.get(url + '/upload-charger-template')
    return response;
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: 'Something went wrong', status: 400
      }
    }
  }
}


export const uploadBulkAcChargers: any = (reqParams: unknown) => async () => {
  try {
    const response = await hwaxios.post(url + '/charger-bulk', reqParams)

    return response;

  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: 'Something went wrong', status: 400
      }
    }
  }
}


export const fetchAcChargerUptimeHistory: any = (reqParams: unknown) => async (dispatch: (arg0: Partial<AcChargerAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
      individualChargerDetailLoader: true
    }
    dispatch(loaderStartAction);
    const response = await hwaxios.get(url + '/charger/uptime-history', { params: reqParams })
    const action: Partial<AcChargerAction> = {
      type: acChargerTypes.FETCH_AC_CHARGER_UPTIME,
      chargerHistoryUptime: response?.data?.data
    }
    dispatch(action)
    if (response?.status === 200) {
      const loaderEndAction: Partial<AcChargerAction> = {
        type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
        individualChargerDetailLoader: false
      }
      dispatch(loaderEndAction);
    }
  } catch (error) {
    const loaderEndAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_CHARGER_DETAIL_LOADER,
      individualChargerDetailLoader: false
    }
    dispatch(loaderEndAction);
    console.error(error)
    throw error
  }
}

export const fetchAcSpuriousChargersData: any = (reqBody: unknown) => async (dispatch: (arg0: Partial<AcChargerAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_PARAMETERS_LOADER,
      chargerParametersTableLoader: true
    }
    dispatch(loaderStartAction);
    const response = await hwaxios.post(url + '/spurious-charger', reqBody)
    const action: Partial<AcChargerAction> = {
      type: acChargerTypes.FETCH_AC_SPURIOUS_CHARGERS_DATA,
      acSpuriousChargers: response.data?.data?.spuriousChargers ?? [],
      acSpuriousChargersCount: response.data?.data?.count,
    }
    dispatch(action)
    if (response?.status === 200 || response?.status === 202) {
      const loaderEndAction: Partial<AcChargerAction> = {
        type: acChargerTypes.SET_AC_PARAMETERS_LOADER,
        chargerParametersTableLoader: false
      }
      dispatch(loaderEndAction);
    }
  } catch (error) {
    const loaderEndAction: Partial<AcChargerAction> = {
      type: acChargerTypes.SET_AC_PARAMETERS_LOADER,
      chargerParametersTableLoader: false
    }
    dispatch(loaderEndAction);
    console.error(error)
    throw error
  }
}

export const setAcSpuriousChargersListTableProps: any = (data) => async (dispatch: (arg0: Partial<AcChargerAction>) => void): Promise<void> => {
  const action: Partial<AcChargerAction> = {
    type: acChargerTypes.SET_AC_SPURIOUS_CHARGERS_LIST_TABLE_PROPS,
    acSpuriousChargersListTableProps: data,
  };
  dispatch(action);
}

export const updateAcSpuriousCharger: any = (reqParams: unknown) => async () => {
  try {
    const { data, status } = await hwaxios.put(url + '/edit-spurious-charger', reqParams)
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return { data: 'Something went wrong', status: 400 }
    }
  }
}

export const exportToCsvForAcSpuriousChargersList: any = (reqParams: unknown) => async () => {
  try {
    const { data, status } = await hwaxios.post(url + '/spurious-chargers-export', reqParams)
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return { data: 'Something went wrong', status: 400 }
    }
  }
}

export const fetchAcUptimeReportChargerData: any = (reqBody: unknown) => async (dispatch: (arg0: Partial<AcChargerAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcChargerAction> = {
      type: acChargerTypes.AC_SET_CHARGER_LOADER,
      chargerTableLoader: true
    }
    dispatch(loaderStartAction);
    const response = await hwaxios.post(url + '/report/uptime-report', reqBody)
    const action: Partial<AcChargerAction> = {
      type: acChargerTypes.FETCH_AC_UPTIME_REPORT_CHARGER_DATA,
      acUptimeReportList: response.data?.data?.uptimeReportList ?? [],
      acUptimeReportListCount: response.data?.data?.uptimeReportListCount,
    }
    dispatch(action)
    if (response?.status === 200 || response?.status === 202) {
      const loaderEndAction: Partial<AcChargerAction> = {
        type: acChargerTypes.AC_SET_CHARGER_LOADER,
        chargerTableLoader: false
      }
      dispatch(loaderEndAction);
    }
  } catch (error) {
    const loaderEndAction: Partial<AcChargerAction> = {
      type: acChargerTypes.AC_SET_CHARGER_LOADER,
      chargerTableLoader: false
    }
    dispatch(loaderEndAction);
    console.error(error)
    throw error
  }
}

export const setAcUptimeChargerListTableProps: any = (data) => async (dispatch: (arg0: Partial<AcChargerAction>) => void): Promise<void> => {
  const action: Partial<AcChargerAction> = {
    type: acChargerTypes.SET_AC_UPTIME_CHARGER_LIST_TABLE_PROPS,
    acUptimeChargerListTableProps: data,
  };
  dispatch(action);
}



export const createAcChargerUpdateCommands: any = (reqParams: unknown) => async () => {
  try {
    const { data, status } = await hwaxios.post(url + '/charger-update-command', reqParams)
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: 'Something went wrong', status: 400
      }
    }
  }
}
export const updateAcChargerUpdateCommand: any = (reqParams: unknown) => async () => {
  try {
    const { data, status } = await hwaxios.put(url + '/charger-update-command', reqParams)
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: 'Something went wrong', status: 400
      }
    }
  }
}

// EXPORT AC CHARGER LIST
export const exportToCsvForAcChargerList: any = (reqParams: unknown) => async () => {
  try {
    const { data, status } = await hwaxios.post(url + '/charger/export-chargers', reqParams)
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return { data: 'Something went wrong', status: 400 }
    }
  }
}

export const exportToCsvForAcUptimeReportChargerList: any = (reqParams: unknown) => async () => {
  try {
    const { data, status } = await hwaxios.post(url + '/report/uptime-report/export', reqParams)
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return { data: 'Something went wrong', status: 400 }
    }
  }
}

export const setAcActiveCertificateRefreshChargerId: any = (chargerId: string | null) => (dispatch: (arg0: Partial<AcChargerAction>) => void): void => {
  const action: Partial<AcChargerAction> = {
    type: acChargerTypes.SET_AC_ACTIVE_CERTIFICATE_REFRESH_CHARGER_ID,
    activeCertificateRefreshChargerId: chargerId
  }
  dispatch(action)
}

export const refreshAcChargerActiveCertificateStatus: any = (chargerId: string) => async (dispatch: (arg0: Partial<AcChargerAction>) => void): Promise<{ success: boolean, message?: string }> => {
  const isRefreshInProgressFor = (id: string) => rmsStore.getState().acChargersReducer.activeCertificateRefreshChargerId === id

  setAcActiveCertificateRefreshChargerId(chargerId)(dispatch)

  try {
    const response = await hwaxios.post(url + '/charger-certificate-info/refresh-status', { chargerId })
    const responseChargerId = response?.data?.data?.chargerId ?? chargerId
    const activeCertificate = response?.data?.data?.activeCertificate

    if (responseChargerId === chargerId && isRefreshInProgressFor(chargerId) && activeCertificate != null) {
      const action: Partial<AcChargerAction> = {
        type: acChargerTypes.UPDATE_AC_CHARGER_ACTIVE_CERTIFICATE,
        chargerId,
        activeCertificate
      }
      dispatch(action)
    }
    return { success: true, message: response?.data?.message }
  } catch (error) {
    console.error(error)
    const message = isAxiosError(error) ? error?.response?.data?.message : undefined
    return { success: false, message }
  } finally {
    if (isRefreshInProgressFor(chargerId)) {
      setAcActiveCertificateRefreshChargerId(null)(dispatch)
    }
  }
}
